import React from 'react'
import { useModals } from '@contexts'

const withRenderModal = (name) => (WrappedComponent) => {
  const Modal = (props) => {
    const [modals, modalsDispatch] = useModals()
    const modalState = modals[name]

    const close = React.useCallback(() => {
      modalsDispatch.close({ name })
    }, [modalsDispatch])

    React.useEffect(() => close, [close])

    if (!modalState) return null

    return (
      <WrappedComponent closeModal={close} modalData={modalState} {...props} />
    )
  }

  return React.memo(Modal)
}

export default withRenderModal
